import { summariesQueryKey, toApiConfig } from '~/business-logic/relationshipSummaryScope';
import { useStore, useStoreActions } from '~/contexts';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const EMPTY_SUMMARIES = [];
export const useClientAgreementSummaries = function useClientAgreementSummaries(customerId) {
    let { refreshOnHookMount = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const isVendor = useStore(selectors.user.isVendor);
    const enabled = !!customerId && !!businessId;
    const { data, isLoading, isBackgroundLoading, error } = useQueryState({
        queryKey: summariesQueryKey({
            kind: 'billableForClient',
            customerId
        }, {
            businessId,
            isVendor
        }),
        queryFn: ()=>api.relationship.getSummaries(toApiConfig({
                kind: 'billableForClient',
                customerId
            }, {
                businessId: businessId,
                isVendor
            })),
        enabled,
        refreshOnHookMount
    });
    return {
        summaries: data !== null && data !== void 0 ? data : EMPTY_SUMMARIES,
        isLoading: enabled && isLoading,
        isBackgroundLoading,
        error
    };
};
